import { CommonModule } from '@angular/common';
import {
    ChangeDetectionStrategy,
    Component,
    inject,
    input,
    TemplateRef,
} from '@angular/core';
import { MatButton } from '@angular/material/button';
import { Router } from '@angular/router';

@Component({
    selector: 'app-error-message',
    templateUrl: './error-message.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [CommonModule, MatButton],
})
export class ErrorMessageComponent {
    header = input.required<string>();
    subHeader = input<TemplateRef<any>>();
    imageUrl = input<string>('/images/login-failed.svg');
    private readonly router = inject(Router);

    home() {
        this.router.navigate(['']);
    }
}
